import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle.min";
import 'select2/dist/js/select2.min.js';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import { AuthProvider } from "./context/AuthContext";
import { VendorAuthProvider } from "./context/VendorAuthContext";
import { CartProvider } from "./context/CartContext";
import { Provider } from "react-redux"
import { store } from "./state/store.js"


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <VendorAuthProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </VendorAuthProvider>
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
